<div class="advisor {{advisorClasses}}" [class.embedded]="embedded" id="advisor-wrapper" style="overflow: hidden">
  <div class="grid-container advisor-wrapper">
    <router-outlet></router-outlet>
  </div>
  <app-footer-partner></app-footer-partner>
  <app-debug></app-debug>
</div>
